import { createContext, useState, useContext } from 'react';

const SignupInviteContext = createContext();

export const SignupInviteProvider = ({ children }) => {
  const [prefillData, setPrefillData] = useState(null);

  return (
    <SignupInviteContext.Provider value={{ prefillData, setPrefillData }}>
      {children}
    </SignupInviteContext.Provider>
  );
};

export const useSignupInvite = () => useContext(SignupInviteContext);
